module.exports = function () {};